import React from 'react';
import { OptionProps, components } from 'react-select';
import { Box } from '@utex/ui-kit';
import { Option } from '../types';
import { Container, Details } from './styles';
import { MarkedLabel } from '../MarkedLabel';

export const OptionView: React.FC<OptionProps<Option>> = (props) => (
  <components.Option {...props}>
    <Container>
      <Box>
        <MarkedLabel inputValue={props.selectProps.inputValue}>{props.data.label}</MarkedLabel>
      </Box>
      <Details>{props.data.item.name}</Details>
    </Container>
  </components.Option>
);
